import { createTheme } from '@mui/material/styles';

const Theme = createTheme({
    palette: {
        primary: {
            main: '#010144',
            light: '#FFFFFF',
            contrastText: '#FFFFFF',
            dark: '#000033',

        },
        secondary: {
            light: '#c3d7ee',
            main: '#FFFFFF',
            dark: '#557cff',
            contrastText: '#FFFFFF'
        },
        warning: {
            main: '#ff623a',
            contrastText: '#010144'
        },
        background: {
            default: '#f0f0f5',
            paper: '#FFFFFF'
        },
        text:
        {
            secondary: '#AAAAAA'
        },

    },

    typography: {

    },
    shape: {
        borderRadius: 5
    },

});

export default (Theme);
